<template id="mollie-single-click-payment">
    <input type="checkbox" name="singleClickPayment" id="singleClickPayment" class="form-check-input" v-on:change="setSingleClickPayment"/>
    <label for="singleClickPayment">
      {{ singleClickPaymentLabel }} BLA BLA
    </label>
</template>
<script>
  export default {
    name: "SingleClickPaymentCheckbox",

    mounted()
    {
    },

    computed: {},

    data: function() {
      return {
        checked: false,
        isVisible: true
      }
    },

    props: {
      isVisible: Boolean
    },

    methods: {
      setSingleClickPayment() {
        $.ajax(
            {
              type: 'PUT',
              url: '/rest/mollie/check_single_click_payment',
              data: {
                singleClickPayment: this.checked
              }
            }
        )
        .done(
            function () {
              console.log('single click payment changed');
            }
        )
        .fail(
            function (msg) {
            }
        );
        sessionStorage.setItem('saveCustomerChecked', this.checked);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/SingleClickPaymentCheckbox.vue